import {powerPlants} from '../actions/powerPlantsArray';
import {upgrades} from '../actions/upgradesArray';
import {finances} from '../actions/financesArray.js';

export class Entity {
  /**
   * Entity constructor
   * - Constructor takes one argument:
   * @param {Array[assoc]} init
   *
   */

  constructor(init){
    //Constant values
    this.name = init.name || "NoName";
    this.type = init.type || "";
    this.instructionsPath = init.instructionsPath || "/";

    this.round = 0;

    //Styling
    this.color = init.color || "rgba(210, 232, 245, .6)";

    //Entity's total money.
    this.funds = init.funds || 0;

    //Entity's total score.
    this.score = init.score || 0;

    //Array of instances of power user bought.
    this.purchasedMwu = [];
    this.soldMwu = [];

    //Entity services. (power plants)
    this.occupiedServiceSlots = this.getOwnedServices(); //Array with all owned services
    this.totalSlots = init.totalSlots || 0; //Maximum services user can own.
    this.slots = init.slots || [];
    //Entity Upgrades.
    this.upgrades = init.upgrades || []; //Upgrades user had purchased.
    this.availableUpgrades = this.getAvailableUpgrades(); //Upgrades user _can_ buy.

    //Amount of MWU the user requires.
    this.mwuNecessity = init.mwuNecessity || 0;

    this.image = require("../assets/elements/" + init.image + ".svg");
    this.imageStyle = init.imageStyle || {display: 'none',};
    this.hudStyle = init.hudStyle || {display: 'none',};

    //Variable specific to Market, purpose is to store it's money!
    this.totalFunds = 0;

    if( init.defaultOwned !== undefined ){
      this.setDefaultOwned( init.defaultOwned );
    }
  }

  getPurchasedUpgrades(){
    this.upgrades = upgrades.filter((current) => {return current.purchased.includes(this.name)});
  }

  /**
   * [setDefaultOwned description]
   * @param {[type]} data [Array of powerplant id's the player shoudl own prior to starting.]
   */
  setDefaultOwned( data ){
    for (let i = 0; i < data.length; i++) {
      /**
       * Loops through the id's, if the id matches, set purchasedby to current object.
       */
      let match = powerPlants.findIndex((current) => { return current.id === data[i] });
      powerPlants[match].purchasedBy = this.name;
    }

    //Update self.
    this.occupiedServiceSlots = this.getOwnedServices();
  }

  /**
   * [getOwnedServices: Gets an array of powerplants a user owns.]
   * @return {array} [Gets an array of powerplants a user owns.]
   */
  getOwnedServices() {
    //Loops through public purchased list and returns the ones owned by entity
    let ownedServices = [];
    for (let i = 0; i < powerPlants.length; i++) {
      if( powerPlants[i].purchasedBy === this.name && powerPlants[i].demolished === false ){
        ownedServices.push(powerPlants[i])
      } else if ( typeof(powerPlants[i].purchasedBy) === "object" && powerPlants[i].purchasedBy.length > 1 ) {
        // eslint-disable-next-line
        if(powerPlants[i].purchasedBy[0] === this.name || powerPlants[i].purchasedBy[1] === this.name && powerPlants[i].demolished === false) {
          ownedServices.push(powerPlants[i]);
        }
      }
    }
    return ownedServices;
  }

  getMwuNecessity(...args){
    let mwuBonus = 0;
    for (let i = 0; i < this.upgrades.length; i++) {
      typeof(this.upgrades[i].mwuBonus) === "number" ? mwuBonus += this.upgrades[i].mwuBonus : mwuBonus += 0;
    }

    //Only loop through the purchased energy if entity has any.
    let totalPurchased = 0;
    if(args[0] !== true){
      //Loop through purchases and add the value to totalPurchased
      if(this.purchasedMwu.length > 0) {
        for (let i = 0; i < this.purchasedMwu.length; i++) {
          if (this.purchasedMwu[i] !== null) {
            totalPurchased += parseInt(this.purchasedMwu[i].mwu, 10);
          }
        }
      }
    }

    let necessity = this.mwuNecessity + mwuBonus - totalPurchased;

    if(necessity < 0){
      return 0;
    } else {
      return necessity;
    }
  }


  /**
   * [getMwuServices description]
   * @return {number} [Returns the total amount of MWU produced/purchased.]
   */
  getMwuServices() {
    //Only loop through the services if entity had any.
    let totalProduction = 0;
    if(this.occupiedServiceSlots.length > 0) {
      //Loop through services and add the value to totalProduction
      for (let i = 0; i < this.occupiedServiceSlots.length; i++) {
        if( typeof(this.occupiedServiceSlots[i].purchasedBy) === "object" && this.occupiedServiceSlots[i].purchasedBy.length > 1 ){
          totalProduction += (parseInt(this.occupiedServiceSlots[i].mwu, 10) / 2);
        } else {
          totalProduction += parseInt(this.occupiedServiceSlots[i].mwu, 10);
        }
      }
    }

    //Check if the entity sold any power before starting the loop
    let totalSold = 0;
    if(this.soldMwu.length > 0) {
      //If the entity sold power, loop through the sold power and add it up
      for (let i = 0; i < this.soldMwu.length; i++) {
        totalSold += parseInt(this.soldMwu[i].mwu, 10);
      }
    }

    //Return the sum of all energy
    return totalProduction - totalSold;
  }

  /**
   * [getProductionTotal description]
   * @return {number} [Returns the total amount of MWU produced.]
   */
  getProductionTotal() {
    //Only loop through the services if entity had any.
    let totalProduction = 0;
    if(this.occupiedServiceSlots.length > 0) {
      //Loop through services and add the value to totalProduction
      for (let i = 0; i < this.occupiedServiceSlots.length; i++) {
        if( typeof(this.occupiedServiceSlots[i].purchasedBy) === "object" && this.occupiedServiceSlots[i].purchasedBy.length > 1 ){
          totalProduction += (parseInt(this.occupiedServiceSlots[i].mwu, 10) / 2);
        } else {
          totalProduction += parseInt(this.occupiedServiceSlots[i].mwu, 10);
        }
      }
    }

    //Return the sum of all energy
    return totalProduction;
  }


  /**
   * [getMwuGreen description]
   * @return {number} [groene stroom in MWU]
   */
  getMwuGreen() {

    //Check if the user has any services before starting a loop.
    let totalProductionGreen = 0;
    if(this.occupiedServiceSlots.length > 0) {
      //If the entity own any services loop through them. Check if energy produced is green, if so, count it up.
      for (let i = 0; i < this.occupiedServiceSlots.length; i++) {
        totalProductionGreen += (this.occupiedServiceSlots[i].green ? this.occupiedServiceSlots[i].mwu : 0);
      }
    }

    //Check if the entity bought any power before starting the loop
    let totalPurchasedGreen = 0;
    if(this.purchasedMwu.length > 0) {
      //If the entity bought power, loop through the bought power and add it up
      for (let i = 0; i < this.purchasedMwu.length; i++) {
        totalPurchasedGreen += (this.purchasedMwu[i].green ? this.purchasedMwu[i].mwu : 0);
      }
    }

    //Check if the entity sold any power before starting the loop
    let totalSoldGreen = 0;
    if(this.soldMwu.length > 0) {
      //If the entity sold power, loop through the sold power and add it up
      for (let i = 0; i < this.soldMwu.length; i++) {
        totalSoldGreen += (this.soldMwu[i].green ? this.soldMwu[i].mwu : 0);
      }
    }
    //Add up the total green power the user has.
    return totalProductionGreen + totalPurchasedGreen - totalSoldGreen;
  }

  getPercentageGreen(){
    let demolishedMwu = powerPlants.filter((current) => {
      if (current.purchasedBy !== false) {
        if(typeof(current.purchasedBy) === "string"){
          return  current.purchasedBy === this.name &&
          current.demolished !== false &&
          current.demolished === this.round;
        } else {
          return  current.purchasedBy.includes(this.name) &&
          current.demolished !== false &&
          current.demolished === this.round;
        }
      }
      return false;
    }).reduce((accumilator, current) => {return accumilator + current.mwu}, 0);
    const purchasedMwu = this.purchasedMwu.reduce((accumilator, current) => { return current.mwu + accumilator}, 0);

    let totalMwu = this.getMwuServices() + demolishedMwu + purchasedMwu;
    let greenMwu = this.getMwuGreen();

    if(this.getMwuGreen() === 0 || totalMwu === 0){
      return 0;
    }

    const pGreen = greenMwu / totalMwu * 100;

    if(pGreen < 0){
      return 0;
    }

    if(pGreen > 100){
      return 100;
    }

    return pGreen;
  }

  getProductionGreen(){
    let demolishedMwu = powerPlants.filter((current) => {
      if (current.purchasedBy !== false) {
        if(typeof(current.purchasedBy) === "string"){
          return  current.purchasedBy === this.name &&
          current.demolished !== false &&
          current.demolished === this.round;
        } else {
          return  current.purchasedBy.includes(this.name) &&
          current.demolished !== false &&
          current.demolished === this.round;
        }
      }
      return false;
    }).reduce((accumilator, current) => {return accumilator + current.mwu}, 0);

    let totalMwu = this.getMwuServices() + demolishedMwu;
    let greenMwu = this.getOwnedServices().filter((current) => { return current.green === true }).reduce((accumilator, current) => { return accumilator + current.mwu }, 0);

    if(this.getMwuGreen() === 0 || totalMwu === 0){
      return 0;
    }

    const pGreen = greenMwu / totalMwu * 100;

    if(pGreen < 0){
      return 0;
    }

    if(pGreen > 100){
      return 100;
    }

    return pGreen;
  }

  getExpensesGreen() {
    const necessity = this.mwuNecessity;
    const allPower = this.getOwnedServices().concat(this.purchasedMwu);

    // First, try to satisfy the demand of the player with green energy.
    const allSoldGreen = this.soldMwu
      .filter(current => current.green)
      .reduce((total, current) => total + current.mwu, 0);

    const allSoldBlack = this.soldMwu
      .filter(current => !current.green)
      .reduce((total, current) => total + current.mwu, 0);

    const allMwuGreen = allPower
      .filter(current => current.green)
      .map((current) => {
        return (typeof(current.purchasedBy) === "object") ? current.mwu / 2 : current.mwu;
      })
      .reduce((total, mwu) => total + mwu, 0) - allSoldGreen;

    const allMwuBlack = allPower
      .filter(current => !current.green)
      .map((current) => {
        return (typeof(current.purchasedBy) === "object") ? current.mwu / 2 : current.mwu;
      })
      .reduce((total, mwu) => total + mwu, 0);

    const purchasedMwuBlack = this.purchasedMwu
      .filter(current => !current.green)
      .reduce((total, current) => total + current.mwu, 0);

    // We need to know how much power is from the storage, because we can't
    // take that to the next round.
    const greenFromStorage = allPower
      .filter(current => current.green)
      .filter(current => current.name === 'storage')
      .reduce((total, current) => total + current.mwu, 0);
    const blackFromStorage = allPower
      .filter(current => !current.green)
      .filter(current => current.name === 'storage')
      .reduce((total, current) => total + current.mwu, 0);

    if(this.type === "supplier"){
      let demolishedMwuGreen = powerPlants.filter((current) => {
        if (current.purchasedBy !== false && current.green) {
          if(typeof(current.purchasedBy) === "string"){
            return  current.purchasedBy === this.name &&
            current.demolished !== false &&
            current.demolished === this.round;
          } else {
            return  current.purchasedBy.includes(this.name) &&
            current.demolished !== false &&
            current.demolished === this.round;
          }
        }
        return false;
      }).reduce((accumilator, current) => {return accumilator + current.mwu}, 0);

      let demolishedMwuBlack = powerPlants.filter((current) => {
        if (current.purchasedBy !== false && !current.green) {
          if(typeof(current.purchasedBy) === "string"){
            return  current.purchasedBy === this.name &&
            current.demolished !== false &&
            current.demolished === this.round;
          } else {
            return  current.purchasedBy.includes(this.name) &&
            current.demolished !== false &&
            current.demolished === this.round;
          }
        }
        return false;
      }).reduce((accumilator, current) => {return accumilator + current.mwu}, 0);

      const allMwuGreenSup = allPower.filter(current => current.green).reduce((total, current) => {
        if(typeof(current.purchasedBy) === "object"){
          return total + (current.mwu / 2);
        } else {
          return total + current.mwu;
        }
      }, 0) + demolishedMwuGreen;

      const allMwuBlackSup = allPower.filter(current => !current.green).reduce((total, current) => {
        if(typeof(current.purchasedBy) === "object"){
          return total + (current.mwu / 2);
        } else {
          return total + current.mwu;
        }
      }, 0) + demolishedMwuBlack;

      const totalMwu = allMwuBlackSup + allMwuGreenSup;


      let percentageGreen = (allMwuGreenSup / totalMwu) * 100;
      if (totalMwu === 0) {
        percentageGreen = 100;
      } else if (allMwuGreenSup === 0) {
        percentageGreen = 0;
      } else if (percentageGreen > 100) {
        percentageGreen = 100;
      } else if(percentageGreen < 0){
        percentageGreen = 0;
      }

      return {
        percentageGreen: percentageGreen,
        nextRoundGreen: allMwuGreen - necessity,
        nextRoundBlack: allMwuBlack,
        allMwuBlack,
        allMwuGreen,
        allSoldGreen,
        allSoldBlack,
      };
    }

    if ( allMwuGreen >= (necessity + purchasedMwuBlack) ) {
      return {
        percentageGreen: 100,
        nextRoundGreen: Math.max(allMwuGreen - (necessity - greenFromStorage), 0),
        nextRoundBlack: Math.max(allMwuBlack - blackFromStorage, 0),
        allMwuBlack,
        allMwuGreen,
        allSoldGreen,
        allSoldBlack,
      };
    } else if (!allMwuGreen && !allMwuBlack) {
      return {
        percentageGreen: 0,
        nextRoundGreen: 0,
        nextRoundBlack: 0,
        allMwuBlack,
        allMwuGreen,
        allSoldGreen,
        allSoldBlack,
      };
    }
    const usedBlack = Math.min(necessity - allMwuGreen, allMwuBlack);
    const usedBothTypes = allMwuGreen + usedBlack;
    // We can now calculate how much green power was used.
    return {
      // Calculate the % green of what you actually used.
      percentageGreen: (allMwuGreen / usedBothTypes) * 100,
      // If you have 10 GREEN and need 5, you can take 10-5 = 5 with you.
      // If you have 5 GREEN and need 10, you can take 5-10 = -5 = 0 with you.
      nextRoundGreen: Math.max(allMwuGreen - (necessity - greenFromStorage), 0),
      // If you have 10 BLACK and used 5, you can take 10 - 5 = 5 with you.
      nextRoundBlack: Math.max(allMwuBlack - blackFromStorage - usedBlack, 0),
      allMwuBlack,
      allMwuGreen,
      allSoldGreen,
    };
  }


  /**
   * [getAvailableServices: returns a list of all services (power plants) the entity can purchase.]
   * @return {array} [Returns an array of available lists]
   */
  getAvailableServices() {
    //Determine what type of services are available to the entity.
    const central = ( this.type === 'supplier' );

    //Loop throught the powerPlants array
    let availableServices = [];
    for (let i = 0; i < powerPlants.length; i++) {

      //If the instance does not have any dependencies nor is purchased and matches the type; it gets added to the array of availableServices
      if(powerPlants[i].purchasedBy === false && powerPlants[i].central === central){

        if( powerPlants[i].dependency === false ){
          availableServices.push(powerPlants[i]);
        } else if (typeof(powerPlants[i].dependency) === "string") {
          //If the powerPlants does have a dependency, check if the dependent plant has been purchased in the past.
          let dependency = powerPlants[i].dependency;

          let match = powerPlants.findIndex((current) => {
            return current.name === dependency
          });

          if(powerPlants[match].purchasedBy !== false){
            availableServices.push(powerPlants[i]);
          }
        }
      }
    }
    return availableServices;
  }

  /**
   * [purchaseServices description]
   * @param  {object} data [Object expects properties:
   *                        - name: [Name of plant user wants to buy]
   *                        - price: [Price the user wants to pay for the object]
   *                       ]
   */
  purchaseServices( data ) {
    //Check if user has any free slots
    try {
      //Check what type of entity it is.
      if(this.type === "city" || this.type === "company") {
        //If it is a city or a company, it can only buy decentral ones, so it has a set amout of slots.
        let internalSlots = this.occupiedServiceSlots.filter((current) => {return current.external === false}).length;
        if( internalSlots >= this.totalSlots ) {
          //If all slots are allready occupied, throw an error.
          throw new Error("Niet genoeg ruimte! Sloop eerst iets!");
        } else {
          //If player is able to buy a service, run the function;
          return this.buyDecentralService( data );
        }
      } else if(this.type === "supplier"){
        return this.buyCentralService( data );
      } else {
        //If the user is none of the types mentioned, throw an error.
        throw new Error("Niet toegestaan om te kopen als huidige speler!");
      }

    } catch (e) {
      return [false, e];
    }
  }

  /**
   * [buyDecentralService description]
   * @param  {object} data [Object expects properties:
   *                        - name: [Name of plant user wants to buy]
   *                        - price: [Price the user wants to pay for the object]
   *                       ]
   */
  buyDecentralService( data ) {
    //Store input
    const decentralToBuy = data.name;
    const negotiatedPrice = parseInt(data.price, 10);

    //Get the list of available services
    const availableCentrals = this.getAvailableServices();

    //Check in a loop whether the chosen service exists and isn't purchased yet
    let isAvailable = false;
    for (let i = 0; i < availableCentrals.length; i++) {
      if(availableCentrals[i].name === decentralToBuy) {
        if(availableCentrals[i].purchasedBy === false){
          isAvailable = true;
        }
        break;
      }
    }

    //Confirm the service is available.
    if(!isAvailable){
      return false;
    } else {
      for (let i = 0; i < powerPlants.length; i++) {
        //Through a loop select the powerplant from the powerPlants object.
        if(powerPlants[i].name === decentralToBuy) {
          //Calculate a new price based on set taxes and subsidies
          const newPrice = negotiatedPrice - parseInt(data.subsidy, 10) + this.getApplicableTaxes(powerPlants[i].id, "powerPlants");;
          //Check whether the price is within the set boundries, and if the player can afford that price.
          if(
            // (negotiatedPrice >= powerPlants[i].basePrice - 100)
            // &&
            // (negotiatedPrice <= powerPlants[i].basePrice + 100)
            // &&
            (newPrice <= this.funds)
          ) {

            if (this.withdrawSubsidies(powerPlants[i].id, "powerPlants", parseInt(data.subsidy, 10))) {
              //In the object, set the owner to the entity.
              powerPlants[i].purchasedBy = this.name;

              //Widthdraw the price from the user funds.
              this.funds = this.funds - newPrice;

              //Update owned services.
              this.occupiedServiceSlots = this.getOwnedServices();

              //Return true to confirm succesful transaction.
              return true;
            } else {
              return false;
            }
          }
        }
      }
    }
    throw new Error("Deze aankoop is te duur!");
  }

  buyCentralService( data ) {
    //Store input
    const centralToBuy = data.name;
    const negotiatedPrice = parseInt(data.price, 10);

    let mutualBuy = (data.buyWith !== false);

    let externalCentral = (data.plot === undefined ? false : true);
    if(!externalCentral){
      let internalSlots = this.occupiedServiceSlots.filter((current) => {return current.external === false}).length;

      if( internalSlots >= this.totalSlots ) {
        throw new Error("Alle slots zijn bezet, overweeg om een plant extern te bouwen.");
      }
    }

    //Get the list of available services
    const availableCentrals = this.getAvailableServices();

    //Check in a loop whether the chosen service exists and isn't purchased yet
    let isAvailable = false;
    for (let i = 0; i < availableCentrals.length; i++) {
      if(availableCentrals[i].name === centralToBuy) {
        if(availableCentrals[i].purchasedBy === false){
          isAvailable = true;
        }
        break;
      }
    }

    if(!isAvailable) {
      return false;
    } else {
      for (let i = 0; i < powerPlants.length; i++) {
        //Through a loop select the powerplant from the powerPlants object.
        if(powerPlants[i].name === centralToBuy) {

          //Calculate a new price based on set taxes and subsidies
          const newPrice = negotiatedPrice - parseInt(data.subsidy, 10) + this.getApplicableTaxes(powerPlants[i].id, "powerPlants");;

          //Check whether the price is within the set boundries.
          if(
            true
            // (negotiatedPrice >= powerPlants[i].basePrice - 100)
            // &&
            // (negotiatedPrice <= powerPlants[i].basePrice + 100)
          ) {
            //Widthdraw the price from the user funds.
            if(mutualBuy){
              const pricePerEntity = Math.ceil(newPrice / 2);

              try {
                if(pricePerEntity > this.funds){
                  throw new Error("Je kunt dit niet betalen!");
                }
                if(pricePerEntity > data.buyWith.funds){
                  throw new Error("De andere partij, "+ data.buyWith.name +",kan dit niet betalen!");
                }

                if (this.withdrawSubsidies(powerPlants[i].id, "powerPlants", parseInt(data.subsidy, 10))) {
                  this.funds -= pricePerEntity;
                  data.buyWith.funds -= pricePerEntity;
                } else {
                  throw new Error("De overheid kan deze subsidie niet betalen!");
                }

              } catch (e) {
                //If either user cannot afford, stop;
                return e;
              }
            } else {
              try {
                if(newPrice > this.funds){
                  throw new Error("Je kunt dit niet betalen!");
                }
                if (this.withdrawSubsidies(powerPlants[i].id, "powerPlants", parseInt(data.subsidy, 10))) {
                  this.funds = this.funds - newPrice;
                } else {
                  throw new Error("De overheid kan deze subsidie niet betalen!");
                }
              } catch (e) {
                //If user cannot afford, stop;
                return e;
              }
            }

            //In the object, set the owner to the entity.
            powerPlants[i].purchasedBy = (mutualBuy ? [this.name, data.buyWith.name] : this.name);

            if(data.plot === undefined){
              powerPlants[i].external = false;
            } else {
              powerPlants[i].external = data.plot;
            }

            //Update owned services.
            this.occupiedServiceSlots = this.getOwnedServices();
            if(mutualBuy) {
              data.buyWith.occupiedServiceSlots = data.buyWith.getOwnedServices();
            }

            //Return true to confirm succesful transaction.
            return true;
          }
        }
      }
    }
  }

  getFinancials(type, id){
    return finances.filter((current) => {
      return current.active && current.affects[0] === type && current.affects[1].includes(id);
    }).reduce((total, current) => {
      return total + current.amount * (current.type === 'subsidy' ? -1 : 1);
    }, 0);
  }

  getApplicableTaxes(id, type){
    return finances.filter((current) => {
      return current.active && current.affects[0] === type && current.type === "tax" && current.affects[1].includes(id);
    }).reduce((total, current) => {
      return total + current.amount;
    }, 0);
  }

  getApplicableSubsidies(id, type, ...marine){
    let marinePlot = false;
    if(marine !== undefined && marine !== null){
      marinePlot = marine[0];
    }

    if(marinePlot === true){
      return finances.filter((current) => {
        return current.active && current.affects[0] === type && current.type === "subsidy" && current.affects[1].includes(id);
      }).reduce((total, current) => {
        return total + current.amount;
      }, 0);
    } else {
      return finances.filter((current) => {
        return current.id !== 2 && current.active && current.affects[0] === type && current.type === "subsidy" && current.affects[1].includes(id);
      }).reduce((total, current) => {
        return total + current.amount;
      }, 0);
    }

  }

  withdrawSubsidies(id, type, amount){
    try {
      let affected = finances.filter((current) => {
        return current.active && current.affects[0] === type && current.type === "subsidy" && current.affects[1].includes(id);
      })

      if(affected.length > 0){
        let amountPerFinance = (amount / affected.length).toFixed(0);
        let pass = true;
        for (var i = 0; i < affected.length; i++) {
          if(parseInt(affected[i].amount, 10) - amountPerFinance < 0){
            pass = false;
          }
        }

        if (pass) {
          for (var d = 0; d < affected.length; d++) {
            affected[d].amount = parseInt(affected[d].amount, 10) - amountPerFinance;
          }
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } catch (e) {
      return false;
    }
  }

  /**
   * [getAvailableUpgrades: checks for upgrades available to the entity.]
   * @return {array} [Returns an array with upgrades available to the entity.]
   */
  getAvailableUpgrades() {
    //Loop through a new instance of upgrades. This is the default upgrades list.
    //When one of the values in 'availability' matches the entity type (and it is not purchased yet)
    //It is added to the availableUpgrades list.
    let availableUpgrades = [];
    for (let i = 0; i < upgrades.length; i++) {
      if( upgrades[i].availability.indexOf( this.type ) !== -1 && upgrades[i].purchased.filter((current) => {return current === this.name}).length === 0 ) {
        availableUpgrades.push(upgrades[i]);
      }
    }
    return availableUpgrades;
  }


  /**
   * [purchaseUpgrade: Lets a player buy an upgrade from the upgrades menu.]
   * @param  {string} upgrade [Name of the upgrade to be purchased.]
   * @param  {number} price   [Negotiated price of the upgrade to be purchased.]
   * @return {boolean}        [True when upgrade was purchased, false when it was declined.]
   */
  purchaseUpgrade(upgrade, price, subsidy){
    //Update the list of upgrades.
    this.availableUpgrades = this.getAvailableUpgrades();

    //Loop through the available upgrades and check for an upgrade that matches the name.
    let upgradeIndex = "";
    for (let i = 0; i < this.availableUpgrades.length; i++) {
      if( this.availableUpgrades[i].name === upgrade ) {
        //If the names match, store the upgrade's index in 'upgradeIndex' and stop the loop.
        upgradeIndex = i;
        break;
      }
    }

    price = parseInt(price, 10);

    try {
      //Check if the loop actually found a matching upgrade. If not, throw an error and stop the script thusfar.
      if(upgradeIndex === ""){
        throw new Error("Geen mogelijke upgrades gevonden!");
      }

      //Check if the set price is according to the game's rules.
      if(
        true
        // (price >= this.availableUpgrades[upgradeIndex].basePrice - 100)
        // &&
        // (price <= this.availableUpgrades[upgradeIndex].basePrice + 100)
      ) {
        //Negotiated upgrade price is within allowed boundries.
        const totalPrice = price - parseInt(subsidy, 10) + this.getApplicableTaxes(upgradeIndex + 1, "upgrades");
        if( totalPrice < 0 ) {
          throw new Error("Prijs kan niet onder de 0!");
        }

        if( totalPrice <= this.funds ) {

          if(this.withdrawSubsidies(upgradeIndex + 1, "upgrades", parseInt(subsidy, 10))){
            //Player can afford upgrade: Set the upgrade to 'purchased' in the availableUpgrades list. This will make it unavailble for a next purchase.
            this.availableUpgrades[upgradeIndex].purchased.push(this.name);

            //Add the upgrade to an array with bought upgrades.
            this.upgrades.push( this.availableUpgrades[upgradeIndex] );

            //Remove the upgrade's price from the funds.
            this.funds -= totalPrice;

            //Update the list of upgrades after it being made unavailble.
            this.availableUpgrades = this.getAvailableUpgrades();

            //Return 'true' to confirm the purchase being approved.
            return true;
          } else {
            throw new Error("Overheid heeft niet voldoende geld.")
          }
        } else {
          //Player can't afford upgrade.
          throw new Error("Deze upgrade is te duur!");
        }
      } else {
        //Negotiated upgrade price is now within allowed boundries.
        throw new Error("Ongeldige prijs; Prijs kan variëren tussen +100 of -100");
      }
    } catch (e) {
      //Return 'e' to confirm the purchase has not gone through.
      return e;
    }
  }

  demolishCentral(data){
    try {
      for (let i = 0; i < this.occupiedServiceSlots.length; i++) {
        if(this.occupiedServiceSlots[i].name === data.name){
          const demolitionCost = this.occupiedServiceSlots[i].basePrice / 2;

          const mutualBuy = ( typeof(this.occupiedServiceSlots[i].purchasedBy) === "object" && this.occupiedServiceSlots[i].purchasedBy.length !== undefined);
          if(mutualBuy){
            const costPerEntity = demolitionCost / 2;

            let entity;
            if(this.occupiedServiceSlots[i].purchasedBy[0] === this.name){
              entity = this.occupiedServiceSlots[i].purchasedBy[1];
            } else {
              entity = this.occupiedServiceSlots[i].purchasedBy[0];
            }

            entity = data.entities.filter((current) => {return current.name === entity})[0];

            if (costPerEntity > this.funds) {
              throw new Error("Je kan dit niet betalen!");
            }
            if (costPerEntity > entity.funds) {
              throw new Error("Andere speler kan dit niet betalen!");
            }

            for (let i = 0; i < powerPlants.length; i++) {
              if( powerPlants[i].name === data.name ){
                powerPlants[i].demolished = this.round;
                break;
              }
            }

            this.occupiedServiceSlots.splice(i, 1);

            for ( let i = 0; i < entity.occupiedServiceSlots.length; i++ ){
              if( entity.occupiedServiceSlots[i].name === data.name ){
                entity.occupiedServiceSlots.splice(i, 1);
              }
            }

            this.funds -= demolitionCost;
            entity.funds -= demolitionCost;

            return true;
          } else {
            if(demolitionCost > this.funds) {
              throw new Error("Onvoldoende budget!");
            }

            for (let i = 0; i < powerPlants.length; i++) {
              if( powerPlants[i].name === data.name ){
                powerPlants[i].demolished = this.round;
              }
            }

            this.occupiedServiceSlots.splice(i, 1);

            this.funds -= demolitionCost;
            return true;
          }
        }
      }
    } catch(e){
      return e;
    }
  }

  getProduction(){
    let necessity = this.getMwuNecessity(true);
    // let necessity = this.mwuNecessity;
    let production = ( this.getMwuServices() + this.purchasedMwu.reduce((total, current) => {return total + current.mwu}, 0) - this.soldMwu.reduce((total, current) => {return total + current.mwu}, 0) );

    const outcome = ( production / necessity )* 100;
    if(necessity === 0){
    // if(necessity === 0 || outcome > 100){
      return 100;
    } else if(production === 0){
    // } else if(production === 0 || outcome < 0){
      return 0;
    } else {
      return outcome;
    }
  }

  async roundChange(...args){
    if(args[0] > this.round){
      this.round = args[0];

      var storage = this.getExpensesGreen();

      if(this.type === 'market') {
        if(this.funds > 0){
          this.totalFunds += this.funds;
        };

        this.funds = 0;
      }

      if(this.type === 'company') {
        const entity = args[1].filter((current) => { return current.name === this.location })[0];

        if( this.getProduction() >= 100 ){
          this.mwuNecessity += 2;
        }

        if( entity.getProduction <= 100 ){
          this.mwuNecessity = (this.mwuNecessity - (this.mwuNecessity * 0.1)).toFixed(0);
        }
      }
      await this.purchasedMwu.splice(0, this.purchasedMwu.length);
      await this.soldMwu.splice(0, this.soldMwu.length);


      if(
        upgrades.find((storage) => { return storage.name === "Opslagcapaciteit"}).purchased.includes(this.name)
      ) {
        let maxStorage = 10;
        if(storage.nextRoundGreen > 0){
          const energy = Math.min(storage.nextRoundGreen, maxStorage);
          maxStorage -= energy;
          this.purchasedMwu.push({
            name: "storage",
            mwu: energy,
            green: true,
          });
        }
        if(storage.nextRoundBlack > 0){
          const energy = Math.min(storage.nextRoundBlack, maxStorage);
          maxStorage -= energy;
          this.purchasedMwu.push({
            name: "storage",
            mwu: energy,
            green: false,
          });
        }
      }
    }
  }

  dummyStorage(){
    var storage = this.getExpensesGreen();
    if(
      upgrades.find((storage) => { return storage.name === "Opslagcapaciteit"}).purchased.includes(this.name)
    ) {
      let toStore = storage.nextRoundGreen + storage.nextRoundBlack;
      if(toStore > 10){
        return 10;
      } else {
        return toStore;
      }
    } else {
      return 0;
    }
  }

  /**
   * [purchaseMwuFromEntity description]
   * @param  {object} data [ - entityToBuyFrom: [object Entity],
                             - mwu: [number Amount to buy],
                             - pricePerMwu: [number Payment per Mwu],
                             - green: [bool, buy green or grey]
   ]
   * @return {bool}        [Confirm / deny succesful transaction]
   */
  purchaseMwuFromEntity(data){
    let serviceAmountSold;
    let sellableMwuTotal;
    let serviceName;
    let serviceGreen;

    try {
      //Check if "entity" looks to be an entity.
      let entity;
      if( typeof(data.entityToBuyFrom) === "object" ){
        entity = data.entityToBuyFrom;
      } else {
        throw new Error("Ongeldige speler!");
      }

      let serviceToBuyFrom;
      if( typeof(data.service) === "string" ){
        serviceToBuyFrom = data.service;
      } else {
        throw new Error("Ongeldige service!");
      }

      //Check if the price is according to market rules
      if( data.pricePerMwu < 5 ){
        throw new Error("Prijs is te laag!");
      }


      serviceName = serviceToBuyFrom;

      serviceToBuyFrom = entity.getOwnedServices().filter((current) => {
        return current.name === serviceToBuyFrom;
      })[0];
      serviceGreen = serviceToBuyFrom.green;

      serviceAmountSold = entity.soldMwu.filter((current) => {
        return current.name === serviceName;
      }).reduce((total, current) => {
        return total + parseInt(current.mwu, 10);
      }, 0);

      sellableMwuTotal = serviceToBuyFrom.mwu - serviceAmountSold;


      if(data.mwu > sellableMwuTotal) {
        throw new Error("Speler heeft niet zo veel stroom!");
      }

      const alterFinances = this.getFinancials("powerPlantsBuyMwu", serviceToBuyFrom.id);

      //Calculate the total price

      const netPrice = data.pricePerMwu * data.mwu;
      const totalPrice = netPrice + (alterFinances * data.mwu);
      // console.log("newdata:", "entity:", entity, "serviceName:", serviceName, "serviceToBuyFrom:", serviceToBuyFrom, "serviceGreen:", serviceGreen, "serviceAmountSold:", serviceAmountSold, "alterFinances:", alterFinances, "totalPrice:", totalPrice);

      //Check if player can afford the purchase
      if( totalPrice > this.funds ){
        throw new Error("Speler kan dit niet betalen!");
      }

      //Add an entry to the buyer's purchased array
      const object1 = {
        name: serviceName,
        owner: entity.name,
        mwu: data.mwu,
        green: serviceGreen
      };
      this.purchasedMwu.push(object1);

      //Add an entry to the sellers sold array
      const object2 = {
        name: serviceName,
        buyer: this.name,
        mwu: data.mwu,
        green: serviceGreen
      };
      entity.soldMwu.push(object2);
      window.store = this.purchasedMwu;


      //Withdraw and deposit into user accounts.
      this.funds -= totalPrice;
      entity.funds += netPrice;

      //Confirm purchase
      return true;
    } catch(e) {
      return e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/classes/Entity.js